<div role="main" class="fc-page">
  <app-header></app-header>
  <app-progress-bar [currentStep]="2"></app-progress-bar>
  <app-meta-bar [referenceId]="service.referenceFileDetails.referenceId || service.getCache('referenceId')"></app-meta-bar>

  <section class="fc-panel">
    <div class="fc-panel-header">
      <h2>Contact Information & Security Verification</h2>
    </div>
    <form [formGroup]="contactForm" (ngSubmit)="proceedToEmailVerification()">
      <div class="fc-panel-body">
        <p class="fc-instructions">Provide your contact details. You will verify your email address in the next step.</p>

        <div class="fc-field-grid">
        <div>
          <label for="firstName">First Name @if (isRequired('firstName')) { <span class="fc-required-text">(Required)</span> }</label>
          <input id="firstName" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('firstName')" type="text" formControlName="firstName" placeholder="Enter First Name" [attr.aria-required]="isRequired('firstName') || null">
        </div>
        <div>
          <label for="lastName">Last Name @if (isRequired('lastName')) { <span class="fc-required-text">(Required)</span> }</label>
          <input id="lastName" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('lastName')" type="text" formControlName="lastName" placeholder="Enter Last Name" [attr.aria-required]="isRequired('lastName') || null">
        </div>
        <div>
          <label for="title">Title @if (isRequired('title')) { <span class="fc-required-text">(Required)</span> }</label>
          <input id="title" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('title')" type="text" formControlName="title" placeholder="Enter Title" [attr.aria-required]="isRequired('title') || null">
        </div>
        <div>
          <label for="organizationName">Organization/Practice Name @if (isRequired('organizationName')) { <span class="fc-required-text">(Required)</span> }</label>
          <input id="organizationName" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('organizationName')" type="text" formControlName="organizationName" placeholder="Enter Organization/Business Name" [attr.aria-required]="isRequired('organizationName') || null">
        </div>
        <div>
          <label for="contactEmail">Email Address <span class="fc-required-text">(Required)</span></label>
          <input id="contactEmail" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('contactEmail')" type="email" formControlName="contactEmail" placeholder="example@example.com" aria-required="true" aria-describedby="contactEmail-error">
          @if (contactForm.get('contactEmail')?.invalid && contactForm.get('contactEmail')?.touched) {
            <div id="contactEmail-error" class="text-danger" role="alert">Please enter a valid email address.</div>
          }
        </div>
        <div>
          <label for="contactPhone">Phone Number @if (isRequired('contactPhone')) { <span class="fc-required-text">(Required)</span> }</label>
          <input id="contactPhone" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('contactPhone')" type="text" formControlName="contactPhone" placeholder="999-999-9999" [attr.aria-required]="isRequired('contactPhone') || null">
        </div>
        <div class="full-width">
          <label for="mailingAddress1">Mailing Address 1 @if (isRequired('mailingAddress1')) { <span class="fc-required-text">(Required)</span> }</label>
          <input id="mailingAddress1" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('mailingAddress1')" type="text" formControlName="mailingAddress1" placeholder="123 Example St." [attr.aria-required]="isRequired('mailingAddress1') || null">
        </div>
        <div class="full-width">
          <label for="mailingAddress2">Mailing Address 2</label>
          <input id="mailingAddress2" class="form-control" type="text" formControlName="mailingAddress2" placeholder="Apt/Suite/Unit/Floor/PO Box">
        </div>
        <div>
          <label for="mailingCity">Mailing City @if (isRequired('mailingCity')) { <span class="fc-required-text">(Required)</span> }</label>
          <input id="mailingCity" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('mailingCity')" type="text" formControlName="mailingCity" placeholder="Enter City" [attr.aria-required]="isRequired('mailingCity') || null">
        </div>
        <div>
          <label for="mailingState">Mailing State @if (isRequired('mailingState')) { <span class="fc-required-text">(Required)</span> }</label>
          <select id="mailingState" class="form-select fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('mailingState')" formControlName="mailingState" [attr.aria-required]="isRequired('mailingState') || null">
            <option value="" [disabled]="(isRequired('mailingState'))" selected>Select State</option>
            @for (state of states; track state) {
              <option [value]="state.Name ?? state.name">{{ state.Name ?? state.name }}</option>
            }
          </select>
        </div>
        <div>
          <label for="mailingZip">Mailing ZIP Code @if (isRequired('mailingZip')) { <span class="fc-required-text">(Required)</span> }</label>
          <input id="mailingZip" class="form-control fc-required-glow" [class.force-required-glow]="shouldHighlightRequired('mailingZip')" type="text" formControlName="mailingZip" placeholder="Enter Zip Code" [attr.aria-required]="isRequired('mailingZip') || null" aria-describedby="mailingZip-error">
          @if (contactForm.get('mailingZip')?.invalid && contactForm.get('mailingZip')?.touched) {
            <div id="mailingZip-error" class="text-danger" role="alert">Please enter a valid ZIP Code.</div>
          }
        </div>
      </div>

      @if (verificationError && !isVerifyingCode) {
        <div class="text-danger mt-3" role="alert">{{ verificationError }}</div>
      }
      </div><!-- end fc-panel-body -->

      <div class="fc-panel-footer fc-panel-footer-between">
        <div class="fc-footer-left">
          <!-- <button type="button" class="btn-secondary-action" (click)="back()">Back</button> -->
          <button type="button" class="btn-secondary-action ms-2" (click)="startOver()">Start Over</button>
        </div>
        <button type="submit" class="btn-enter" [disabled]="contactForm.invalid || isSendingCode">
          {{ isSendingCode ? 'Sending Code...' : 'Proceed to Email Verification &gt;' }}
        </button>
      </div>
    </form>
  </section>

  <app-footer [positionFixed]="false"></app-footer>
</div>

<ng-template #emailVerificationModal>
  <div class="modal-header">
    <h4 class="modal-title" id="emailVerificationFormLabel">Email Verification</h4>
  </div>
  <div class="modal-body">
    <app-re-captcha (captchaEvent)="onCaptchaResolved($event)"></app-re-captcha>
    <p class="mt-3 mb-2 text-black">
      You will receive a six-digit verification code from
      filecapture@gainwelltechnologies.com,
      please enter that code in the field below and click the Submit button.
    </p>
    <div class="ev-input-row">
      <label for="verificationCode" class="visually-hidden">Verification Code</label>
      <input id="verificationCode" class="form-control" maxlength="6"
        [(ngModel)]="verificationCode" [ngModelOptions]="{standalone: true}"
        placeholder="Enter the 6-Digit Code Here" aria-required="true" aria-describedby="verificationCode-error">
      <button type="button" class="btn-enter" (click)="validateCode()"
        [disabled]="!captchaValidated || !verificationCode || verificationCode.length !== 6 || isVerifyingCode">
        {{ isVerifyingCode ? 'Verifying...' : 'Submit' }}
      </button>
    </div>
    @if (verificationError) {
      <div id="verificationCode-error" class="text-danger mt-2" role="alert">{{ verificationError }}</div>
    }
    <p class="mt-3 mb-2 text-muted text-black" style="font-size:0.9rem;">
      If you did not receive a code, please correct your email address or click the Resend Code button below.
    </p>
    <button type="button" class="btn-clear" (click)="resendCode()" [disabled]="isSendingCode">Resend Code</button>
    <button type="button" class="btn-clear ms-2" (click)="cancelVerification()">Cancel</button>
  </div>
</ng-template>
